<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/amplifier/gf.jpg" alt="功放系列">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">功放系列</div>
                <div class="detail-banner-desc">
                    自研车载功放；<br />
                    先进DSP音频处理技术，高保真还原细腻原声；<br />
                    分级式平台化设计，从成本优化的Booster平台到高性能功放平台，适配多元声学场景需求；<br />
                    具有：大功率、模块化、接口丰富、防水功放、高效率、高算力、低失真、绿色环保等特点。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AB8 8通道Booster</div>
                    <div class="detail-desc">
                        <div>
                            硬件，结构平台化设计
                        </div>
                        <div>
                            功放结构自带安装脚
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AB8.jpg" alt="AB8 8通道Booster">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">134×119×33</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">600W</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.1% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞85dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">A2B唤醒</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">8通道输出，最多可驱动13扬声器</div>
                                    <div class="k"></div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">兼容4通道或8通道全升压</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">支持多个A2B Booster级联</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">8通道输出，最多可驱动13扬声器</div>
                                    <div class="k"></div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">兼容4通道或8通道全升压</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">支持多个A2B Booster级联</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AB8.jpg" alt="AB8 8通道Booster">
                    </div>
                </div> -->
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD12 12通道功放</div>
                    <div class="detail-desc">
                        <div>
                            硬件，结构，软件平台化设计
                        </div>
                        <div>
                            AUTOSAR 软件架构
                        </div>
                        <div>
                            支持HSCAN 通信
                        </div>
                        <div>
                            支持OTA软件升级
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD12.jpg" alt="AD12 12通道功放">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">198×150×40</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">620W</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.1% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞85dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">12通道输出，最多可驱动17扬声器</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">立体声、2D环绕、多皇帝位、 iESE模拟声浪、ENAC发动机降噪等</div>
                                    <div class="k">高算力，支持多种个性化音效功能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">198×150×40</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">620W</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.1% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞85dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">12通道输出，最多可驱动17扬声器</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">立体声、2D环绕、多皇帝位、 iESE模拟声浪、ENAC发动机降噪等</div>
                                    <div class="k">高算力，支持多种个性化音效功能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD12.jpg" alt="AD12 12通道功放">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD20 20通道功放</div>
                    <div class="detail-desc">
                        <div>
                            硬件，结构，软件平台化设计
                        </div>
                        <div>
                            内置电源管理
                        </div>
                        <div>
                            AUTOSAR 软件架构
                        </div>
                        <div>
                            支持HSCAN 通信
                        </div>
                        <div>
                            支持OTA软件升级
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD20.jpg" alt="AD20 20通道功放">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">236×148×42</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1220W</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.03% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞90dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">20通道输出，最多可驱动27个扬声器</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">支持A2B级联Booster扩展输出通道</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">立体声、2D环绕、3D环绕、4D座椅律动，7.1.4全景声、iESE模拟声浪、ENAC发动机降噪、RNAC路噪控制、头枕环绕等</div>
                                    <div class="k">高算力，支持豪华音效功能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD20.jpg" alt="AD20 20通道功放">
                    </div>
                </div> -->
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD24 24通道功放</div>
                    <div class="detail-desc">
                        <div>
                            硬件，结构，软件平台化设计
                        </div>
                        <div>
                            内置电源管理
                        </div>
                        <div>
                            AUTOSAR 软件架构
                        </div>
                        <div>
                            支持HSCAN/CANFD 通信/Partial Networking
                        </div>
                        <div>
                            支持OTA软件升级
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD24.jpg" alt="AD24 24通道功放">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">306×166×48</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">2400W，全Class D功放架构</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.01% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞90dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">306×166×48</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">2400W，全Class D功放架构</div>
                                    <div class="k">额定功率</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.01% @1W/1kHz</div>
                                    <div class="k">失真度</div>
                                </div> 
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞90dB @1W/1kHz</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">24通道输出，最多可驱动35个扬声器</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">支持A2B级联Booster扩展输出通道</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">立体声、2D环绕、3D环绕、4D座椅律动，7.1.4全景声、iESE模拟声浪、高阶ENAC发动机降噪&RNAC路噪控制、头枕环绕等</div>
                                    <div class="k">高算力，支持全场景沉浸式音效与功</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD24.jpg" alt="AD24 24通道功放">
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '功放系列 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/amplifier.html'
};

import { createApp } from 'vue';
import App from './amplifier.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./amplifier.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
